export default __webpack_public_path__ + "static/media/ellipses.d547ec49.svg";